<template>
  <div class="menu-wrapper" v-if="showMenu">
    <b-dropdown
      position="is-bottom-left"
      aria-role="list"
      :close-on-click="true"
      v-if="showLanguage"
    >
      <a class="navbar-item" slot="trigger" role="button">
        <b-icon icon="web"></b-icon>
        <b-icon icon="menu-down"></b-icon>
      </a>
      <b-dropdown-item
        v-for="language in languages"
        :key="language.value"
        @click="switchLanguage(language.value)"
      >
        {{ $t(`languages.${language.value}`) }}
      </b-dropdown-item>
    </b-dropdown>
    <b-dropdown
      position="is-bottom-left"
      aria-role="list"
      :close-on-click="true"
    >
      <a class="navbar-item" slot="trigger" role="button">
        <span>{{ user ? user.fullname : '' }}</span>
        <b-icon icon="menu-down"></b-icon>
      </a>
      <b-dropdown-item
        v-if="isSurrogateAvailable"
        @click="showSurrogateModal()"
      >
        {{ $t('surrogate') }}
      </b-dropdown-item>
      <b-dropdown-item
        v-if="isStopSurrogateAvailable"
        @click="stopSurrogating()"
      >
        {{ $t('stop_surrogating') }}
      </b-dropdown-item>
      <b-dropdown-item :has-link="true">
        <router-link class="dropdown-item" to="/view/profile">
          {{ $t('view_profile') }}
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="userAllowedTools.some((allowedTool) => allowedTool === 'admin')"
        :has-link="true"
      >
        <router-link class="dropdown-item" to="/view/fleetdata">
          {{ $t('manage_fleet_data') }}</router-link
        >
      </b-dropdown-item>
      <b-dropdown-item
        target="_blank"
        href="https://siemensenergy.service-now.com/sp?id=sc_cat_item&sys_id=7cdbfb151b9ca55047071065bb4bcbb9"
      >
        {{ $t('report_issue') }}
      </b-dropdown-item>
      <b-dropdown-item
        target="_blank"
        href="https://siemensenergyagnam.sharepoint.com/sites/svc/pi/sd/dia/WORKING%20DOCUMENTS/Forms/AllItems.aspx?FolderCTID=0x01200099D9073A38C01644BAC9A44F7AB83416&id=%2Fsites%2Fsvc%2Fpi%2Fsd%2Fdia%2FWORKING%20DOCUMENTS%2FTraining%20Videos"
      >
        {{ $t('training') }}
      </b-dropdown-item>
      <b-dropdown-item
        target="_blank"
        href="https://engage.cloud.microsoft/main/org/siemensenergyag.onmicrosoft.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIzODI5ODAwOTYxIn0"
      >
        {{ $t('forum') }}
      </b-dropdown-item>

      <b-dropdown-item href="/logout"> {{ $t('log_out') }} </b-dropdown-item>
    </b-dropdown>

    <switch-language
      @isActiveSwitchLanguage="handleActiveSwitchLanguage($event)"
      :isModalActive="isSwitchLanguageModalVisible"
    ></switch-language>
    <user-picker
      v-if="isSurrogateModalVisible"
      :user="user"
      @cancel="hideSurrogateModal"
      @ok="handleSurrogateUser"
    />
  </div>
</template>

<script>
import SwitchLanguage from './SwitchLanguage';
import UserPicker from './UserPicker';

export default {
  components: {
    'switch-language': SwitchLanguage,
    'user-picker': UserPicker,
  },

  data() {
    return {
      showMenu: true,
      isSwitchLanguageModalVisible: false,
      isSurrogateModalVisible: false,
      showLanguage: true,
      languages: [
        {
          value: 'en',
          title: 'English',
        },
        {
          value: 'de',
          title: 'German',
        },
        {
          value: 'pt',
          title: 'Portuguese',
        },
        {
          value: 'it',
          title: 'Italian',
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    surrogate() {
      return this.$store.state.surrogateUser;
    },
    userAllowedTools() {
      return this.$store.state.currentUserAllowedTools;
    },
    isSurrogateAvailable() {
      return (
        this.user &&
        this.user.role === 'admin' &&
        this.user.privil.toString() === '1'
      );
    },
    isStopSurrogateAvailable() {
      return !!this.surrogate;
    },
  },
  mounted() {
    const myself = this;
    document.addEventListener(
      'hideVueMenu',
      () => {
        myself.showMenu = false;
      },
      false
    );
    document.addEventListener(
      'showVueMenu',
      () => {
        myself.showMenu = true;
      },
      false
    );
  },

  methods: {
    handleActiveSwitchLanguage(isActive) {
      this.isSwitchLanguageModalVisible = isActive;
    },
    openLanguageModal() {
      this.isSwitchLanguageModalVisible = true;
    },
    showSurrogateModal() {
      this.isSurrogateModalVisible = true;
    },
    hideSurrogateModal() {
      this.isSurrogateModalVisible = false;
    },
    async handleSurrogateUser(user) {
      this.hideSurrogateModal();
      if (user && user._id !== this.surrogate?._id) {
        await this.$store.dispatch('surrogate', user);
      } else {
        await this.$store.dispatch('clearSurrogate', user);
      }
      location.reload();
    },
    async stopSurrogating() {
      await this.$store.dispatch('clearSurrogate');
      location.reload();
    },
    switchLanguage(languageSelected) {
      const defaultLanguage = this.$cookies.get('lang');
      this.$cookies.set('lang', languageSelected);

      if (defaultLanguage !== languageSelected) {
        return location.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-wrapper {
  display: flex !important;
  align-items: center;
}
</style>
